import { ThemeProvider } from "@sinecycle/growcomponents";
import useTheme from "./use-theme";

interface GrowThemeProviderProps {
  children: React.ReactNode;
}

function GrowThemeProvider(props: GrowThemeProviderProps) {
  const { config } = useTheme();
  return <ThemeProvider themeConfig={config}>{props.children}</ThemeProvider>;
}

export { GrowThemeProvider };
